import script from "./menusCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./menusCheck.vue?vue&type=script&setup=true&lang=js"

import "./menusCheck.vue?vue&type=style&index=0&id=e9322846&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9322846"]])

export default __exports__